export enum Status {
  Idle,
  Loading,
  Success,
  Error,
}
